// // // // // import { useEffect, useState, useCallback } from "react";
// // // // // import {
// // // // //   TextField,
// // // // //   Button,
// // // // //   Box,
// // // // //   Typography,
// // // // //   Card,
// // // // //   CardContent,
// // // // //   TableContainer,
// // // // //   Table,
// // // // //   TableHead,
// // // // //   TableRow,
// // // // //   TableCell,
// // // // //   TableBody,
// // // // //   Paper,
// // // // //   Select,
// // // // //   MenuItem,
// // // // //   FormControl,
// // // // //   InputLabel,
// // // // //   Grid,
// // // // //   useMediaQuery,
// // // // //   useTheme,
// // // // // } from "@mui/material";
// // // // // import { useStateContext } from "../context/ContextProvider";
// // // // // import axiosClient from "../axiosClient";
// // // // // import { useTranslation } from "react-i18next";

// // // // // const SearchUsers = () => {
// // // // //   const [searchTerm, setSearchTerm] = useState("");
// // // // //   const [searchCriteria, setSearchCriteria] = useState("username");
// // // // //   const [users, setUsers] = useState([]);
// // // // //   const [searchedUsers, setSearchedUsers] = useState(users);
// // // // //   const [loading, setLoading] = useState(false);
// // // // //   const [error, setError] = useState(null);
// // // // //   const { token } = useStateContext();
// // // // //   const { t } = useTranslation();
// // // // //   const theme = useTheme();
// // // // //   const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

// // // // //   const handleSearch = useCallback(() => {
// // // // //     const filteredUsers = users.filter((user) => {
// // // // //       const value = String(user[searchCriteria]).toLowerCase();
// // // // //       return value.includes(searchTerm.toLowerCase());
// // // // //     });
// // // // //     setSearchedUsers(filteredUsers);
// // // // //   }, [searchCriteria, searchTerm, users]);

// // // // //   useEffect(() => {
// // // // //     if (!token) {
// // // // //       setError("User is not authenticated. Please log in.");
// // // // //       return;
// // // // //     }

// // // // //     const fetchUsers = async () => {
// // // // //       setLoading(true);
// // // // //       setError(null);
// // // // //       try {
// // // // //         const { data } = await axiosClient.get("api/print_all_users/");
// // // // //         setUsers(data.custom_users);
// // // // //       } catch (error) {
// // // // //         setError(
// // // // //           error.response?.data?.message || "An error occurred while fetching users."
// // // // //         );
// // // // //       } finally {
// // // // //         setLoading(false);
// // // // //       }
// // // // //     };

// // // // //     fetchUsers();
// // // // //   }, [token]);

// // // // //   useEffect(() => {
// // // // //     handleSearch();
// // // // //   }, [handleSearch]);

// // // // //   const getRoleDisplay = (role) => {
// // // // //     switch (role) {
// // // // //       case "ADMIN":
// // // // //         return "Secretary (Admin)";
// // // // //       case "STAFF":
// // // // //         return "Doctor (Staff)";
// // // // //       case "CLIENT":
// // // // //         return "Patient (Client)";
// // // // //       default:
// // // // //         return "Non Declared";
// // // // //     }
// // // // //   };

// // // // //   return (
// // // // //     <Box
// // // // //       sx={{
// // // // //         p: { xs: 1, sm: 2 },
// // // // //         display: "flex",
// // // // //         justifyContent: "center",
// // // // //         alignItems: "center",
// // // // //         minHeight: "100vh",
// // // // //         bgcolor: "background.default",
// // // // //       }}
// // // // //     >
// // // // //       <Card
// // // // //         elevation={isMobile ? 4 : 16}
// // // // //         sx={{
// // // // //           width: "100%",
// // // // //           maxWidth: { xs: "100%", sm: 900 },
// // // // //           mx: { xs: 0, sm: 2 },
// // // // //           borderRadius: 2,
// // // // //         }}
// // // // //       >
// // // // //         <CardContent sx={{ p: { xs: 2, sm: 3 } }}>
// // // // //           <Typography
// // // // //             variant={isMobile ? "h6" : "h5"}
// // // // //             sx={{ mb: { xs: 2, sm: 3 }, textAlign: "center", fontWeight: "medium" }}
// // // // //           >
// // // // //             {t("Search Users")}
// // // // //           </Typography>
// // // // //           <Grid container spacing={{ xs: 1, sm: 2 }} sx={{ mb: { xs: 2, sm: 3 } }}>
// // // // //             <Grid item xs={12} sm={6}>
// // // // //               <FormControl fullWidth size={isMobile ? "small" : "medium"}>
// // // // //                 <InputLabel>{t("Search By")}</InputLabel>
// // // // //                 <Select
// // // // //                   value={searchCriteria}
// // // // //                   onChange={(e) => setSearchCriteria(e.target.value)}
// // // // //                   label={t("Search By")}
// // // // //                 >
// // // // //                   {/* <MenuItem value="username">{t("Username")}</MenuItem> */}
// // // // //                   <MenuItem value="first_name">{t("First Name")}</MenuItem>
// // // // //                   <MenuItem value="last_name">{t("Last Name")}</MenuItem>
// // // // //                   {/* <MenuItem value="id">{t("ID Number")}</MenuItem> */}
// // // // //                   {/* <MenuItem value="id_card">{t("ID Card")}</MenuItem> */}
// // // // //                   <MenuItem value="phone_number">{t("Phone Number")}</MenuItem>
// // // // //                   <MenuItem value="email">{t("Email")}</MenuItem>
// // // // //                 </Select>
// // // // //               </FormControl>
// // // // //             </Grid>
// // // // //             <Grid item xs={12} sm={6}>
// // // // //               <TextField
// // // // //                 label={t("Search Term")}
// // // // //                 value={searchTerm}
// // // // //                 onChange={(e) => setSearchTerm(e.target.value)}
// // // // //                 fullWidth
// // // // //                 size={isMobile ? "small" : "medium"}
// // // // //                 variant="outlined"
// // // // //               />
// // // // //             </Grid>
// // // // //           </Grid>
// // // // //           <Box sx={{ display: "flex", justifyContent: "center", mb: { xs: 2, sm: 3 } }}>
// // // // //             <Button
// // // // //               variant="contained"
// // // // //               color="primary"
// // // // //               onClick={handleSearch}
// // // // //               size={isMobile ? "medium" : "large"}
// // // // //               sx={{ px: isMobile ? 3 : 4 }}
// // // // //             >
// // // // //               {t("Search")}
// // // // //             </Button>
// // // // //           </Box>
// // // // //           {loading && (
// // // // //             <Typography sx={{ textAlign: "center", mb: 2, color: "text.secondary" }}>
// // // // //               Loading...
// // // // //             </Typography>
// // // // //           )}
// // // // //           {error && (
// // // // //             <Typography
// // // // //               color="error"
// // // // //               sx={{ textAlign: "center", mb: 2, fontSize: { xs: "0.875rem", sm: "1rem" } }}
// // // // //             >
// // // // //               {error}
// // // // //             </Typography>
// // // // //           )}
// // // // //           <TableContainer
// // // // //             component={Paper}
// // // // //             sx={{
// // // // //               maxHeight: { xs: 300, sm: 500 },
// // // // //               overflowY: "auto",
// // // // //               overflowX: "auto",
// // // // //               boxShadow: "none",
// // // // //             }}
// // // // //           >
// // // // //             <Table
// // // // //               size={isMobile ? "small" : "medium"}
// // // // //               stickyHeader
// // // // //               sx={{
// // // // //                 minWidth: isMobile ? 600 : 650,
// // // // //                 "& .MuiTableCell-head": {
// // // // //                   bgcolor: "grey.700",
// // // // //                   color: "grey.200",
// // // // //                   fontWeight: "medium",
// // // // //                   fontSize: { xs: "0.75rem", sm: "0.875rem" },
// // // // //                   py: isMobile ? 1 : 1.5,
// // // // //                 },
// // // // //                 "& .MuiTableCell-body": {
// // // // //                   fontSize: { xs: "0.75rem", sm: "0.875rem" },
// // // // //                   py: isMobile ? 0.75 : 1,
// // // // //                 },
// // // // //               }}
// // // // //             >
// // // // //               <TableHead>
// // // // //                 <TableRow>
// // // // //                   <TableCell>{t("Name")}</TableCell>
// // // // //                   <TableCell>{t("Surname")}</TableCell>
// // // // //                   <TableCell>{t("Email")}</TableCell>
// // // // //                   <TableCell>{t("Username")}</TableCell>
// // // // //                   <TableCell>{t("Phone Number")}</TableCell>
// // // // //                   <TableCell>{t("Role")}</TableCell>
// // // // //                 </TableRow>
// // // // //               </TableHead>
// // // // //               <TableBody>
// // // // //                 {searchedUsers.map((user) => (
// // // // //                   <TableRow
// // // // //                     key={user.id}
// // // // //                     sx={{
// // // // //                       "& .MuiTableCell-body": {
// // // // //                         borderBottom: `1px solid ${theme.palette.divider}`,
// // // // //                       },
// // // // //                     }}
// // // // //                   >
// // // // //                     <TableCell>{user.first_name}</TableCell>
// // // // //                     <TableCell>{user.last_name}</TableCell>
// // // // //                     <TableCell>{user.email}</TableCell>
// // // // //                     <TableCell>{user.username}</TableCell>
// // // // //                     <TableCell>{user.phone_number}</TableCell>
// // // // //                     <TableCell>{getRoleDisplay(user.user_role)}</TableCell>
// // // // //                   </TableRow>
// // // // //                 ))}
// // // // //               </TableBody>
// // // // //             </Table>
// // // // //           </TableContainer>
// // // // //         </CardContent>
// // // // //       </Card>
// // // // //     </Box>
// // // // //   );
// // // // // };

// // // // // export default SearchUsers;


// // // // import { useEffect, useState, useCallback } from "react";
// // // // import {
// // // //   TextField,
// // // //   Button,
// // // //   Box,
// // // //   Typography,
// // // //   Card,
// // // //   CardContent,
// // // //   TableContainer,
// // // //   Table,
// // // //   TableHead,
// // // //   TableRow,
// // // //   TableCell,
// // // //   TableBody,
// // // //   Paper,
// // // //   Select,
// // // //   MenuItem,
// // // //   FormControl,
// // // //   InputLabel,
// // // //   Grid,
// // // //   useMediaQuery,
// // // //   useTheme,
// // // // } from "@mui/material";
// // // // import axiosClient from "../axiosClient";
// // // // import { useTranslation } from "react-i18next";

// // // // const pickUsersFromResponse = (data) => {
// // // //   if (!data) return [];
// // // //   if (Array.isArray(data)) return data;
// // // //   if (Array.isArray(data?.results)) return data.results;
// // // //   if (Array.isArray(data?.custom_users)) return data.custom_users;
// // // //   if (Array.isArray(data?.users)) return data.users;
// // // //   return [];
// // // // };

// // // // const SearchUsers = () => {
// // // //   const [searchTerm, setSearchTerm] = useState("");
// // // //   const [searchCriteria, setSearchCriteria] = useState("first_name"); // ✅ fixed
// // // //   const [users, setUsers] = useState([]);
// // // //   const [searchedUsers, setSearchedUsers] = useState([]);
// // // //   const [loading, setLoading] = useState(false);
// // // //   const [error, setError] = useState(null);

// // // //   const { t } = useTranslation();
// // // //   const theme = useTheme();
// // // //   const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

// // // //   const handleSearch = useCallback(() => {
// // // //     const term = searchTerm.trim().toLowerCase();
// // // //     if (!term) {
// // // //       setSearchedUsers(users);
// // // //       return;
// // // //     }

// // // //     const filtered = users.filter((u) => {
// // // //       const raw = u?.[searchCriteria];
// // // //       const value = raw === null || raw === undefined ? "" : String(raw).toLowerCase();
// // // //       return value.includes(term);
// // // //     });

// // // //     setSearchedUsers(filtered);
// // // //   }, [searchCriteria, searchTerm, users]);

// // // //   useEffect(() => {
// // // //     const fetchUsers = async () => {
// // // //       setLoading(true);
// // // //       setError(null);
// // // //       try {
// // // //         // ✅ NEW endpoint
// // // //         const res = await axiosClient.get("api/users/");
// // // //         const list = pickUsersFromResponse(res.data);
// // // //         setUsers(list);
// // // //         setSearchedUsers(list);
// // // //       } catch (e) {
// // // //         setError(e.response?.data?.detail || "An error occurred while fetching users.");
// // // //       } finally {
// // // //         setLoading(false);
// // // //       }
// // // //     };

// // // //     fetchUsers();
// // // //   }, []);

// // // //   useEffect(() => {
// // // //     handleSearch();
// // // //   }, [handleSearch]);

// // // //   const getRoleDisplay = (role) => {
// // // //     switch (role) {
// // // //       case "ADMIN":
// // // //         return "Secretary (Admin)";
// // // //       case "STAFF":
// // // //         return "Doctor (Staff)";
// // // //       case "CLIENT":
// // // //         return "Patient (Client)";
// // // //       default:
// // // //         return "Non Declared";
// // // //     }
// // // //   };

// // // //   return (
// // // //     <Box sx={{ p: { xs: 1, sm: 2 }, display: "flex", justifyContent: "center", minHeight: "100vh" }}>
// // // //       <Card elevation={isMobile ? 4 : 16} sx={{ width: "100%", maxWidth: 900, borderRadius: 2 }}>
// // // //         <CardContent sx={{ p: { xs: 2, sm: 3 } }}>
// // // //           <Typography variant={isMobile ? "h6" : "h5"} sx={{ mb: 2, textAlign: "center" }}>
// // // //             {t("Search Users")}
// // // //           </Typography>

// // // //           <Grid container spacing={2} sx={{ mb: 2 }}>
// // // //             <Grid item xs={12} sm={6}>
// // // //               <FormControl fullWidth size={isMobile ? "small" : "medium"}>
// // // //                 <InputLabel>{t("Search By")}</InputLabel>
// // // //                 <Select
// // // //                   value={searchCriteria}
// // // //                   onChange={(e) => setSearchCriteria(e.target.value)}
// // // //                   label={t("Search By")}
// // // //                 >
// // // //                   <MenuItem value="first_name">{t("First Name")}</MenuItem>
// // // //                   <MenuItem value="last_name">{t("Last Name")}</MenuItem>
// // // //                   <MenuItem value="phone_number">{t("Phone Number")}</MenuItem>
// // // //                   <MenuItem value="email">{t("Email")}</MenuItem>
// // // //                 </Select>
// // // //               </FormControl>
// // // //             </Grid>

// // // //             <Grid item xs={12} sm={6}>
// // // //               <TextField
// // // //                 label={t("Search Term")}
// // // //                 value={searchTerm}
// // // //                 onChange={(e) => setSearchTerm(e.target.value)}
// // // //                 fullWidth
// // // //                 size={isMobile ? "small" : "medium"}
// // // //               />
// // // //             </Grid>
// // // //           </Grid>

// // // //           <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
// // // //             <Button variant="contained" onClick={handleSearch}>
// // // //               {t("Search")}
// // // //             </Button>
// // // //           </Box>

// // // //           {loading && <Typography sx={{ textAlign: "center", mb: 2 }}>Loading...</Typography>}
// // // //           {error && <Typography color="error" sx={{ textAlign: "center", mb: 2 }}>{error}</Typography>}

// // // //           <TableContainer component={Paper} sx={{ maxHeight: 500, overflowY: "auto" }}>
// // // //             <Table size={isMobile ? "small" : "medium"} stickyHeader sx={{ minWidth: 650 }}>
// // // //               <TableHead>
// // // //                 <TableRow>
// // // //                   <TableCell>{t("Name")}</TableCell>
// // // //                   <TableCell>{t("Surname")}</TableCell>
// // // //                   <TableCell>{t("Email")}</TableCell>
// // // //                   <TableCell>{t("Username")}</TableCell>
// // // //                   <TableCell>{t("Phone Number")}</TableCell>
// // // //                   <TableCell>{t("Role")}</TableCell>
// // // //                 </TableRow>
// // // //               </TableHead>
// // // //               <TableBody>
// // // //                 {searchedUsers.map((u) => (
// // // //                   <TableRow key={u.id}>
// // // //                     <TableCell>{u.first_name}</TableCell>
// // // //                     <TableCell>{u.last_name}</TableCell>
// // // //                     <TableCell>{u.email}</TableCell>
// // // //                     <TableCell>{u.username}</TableCell>
// // // //                     <TableCell>{u.phone_number}</TableCell>
// // // //                     <TableCell>{getRoleDisplay(u.user_role)}</TableCell>
// // // //                   </TableRow>
// // // //                 ))}
// // // //               </TableBody>
// // // //             </Table>
// // // //           </TableContainer>
// // // //         </CardContent>
// // // //       </Card>
// // // //     </Box>
// // // //   );
// // // // };

// // // // export default SearchUsers;


// // // import { useEffect, useState, useCallback } from "react";
// // // import {
// // //   TextField,
// // //   Button,
// // //   Box,
// // //   Typography,
// // //   Card,
// // //   CardContent,
// // //   TableContainer,
// // //   Table,
// // //   TableHead,
// // //   TableRow,
// // //   TableCell,
// // //   TableBody,
// // //   Paper,
// // //   Select,
// // //   MenuItem,
// // //   FormControl,
// // //   InputLabel,
// // //   Grid,
// // //   useMediaQuery,
// // //   useTheme,
// // //   CircularProgress,
// // // } from "@mui/material";
// // // import axiosClient from "../axiosClient";
// // // import { useTranslation } from "react-i18next";

// // // const pickUsersFromResponse = (data) => {
// // //   if (!data) return [];
// // //   if (Array.isArray(data)) return data;
// // //   if (Array.isArray(data?.results)) return data.results;
// // //   if (Array.isArray(data?.custom_users)) return data.custom_users;
// // //   if (Array.isArray(data?.users)) return data.users;
// // //   return [];
// // // };

// // // const SearchUsers = () => {
// // //   const [searchTerm, setSearchTerm] = useState("");
// // //   const [searchCriteria, setSearchCriteria] = useState("first_name");
// // //   const [users, setUsers] = useState([]);
// // //   const [searchedUsers, setSearchedUsers] = useState([]);
// // //   const [loading, setLoading] = useState(false);
// // //   const [error, setError] = useState(null);

// // //   const { t } = useTranslation();
// // //   const theme = useTheme();
// // //   const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

// // //   const handleSearch = useCallback(() => {
// // //     const term = searchTerm.trim().toLowerCase();
// // //     if (!term) {
// // //       setSearchedUsers(users);
// // //       return;
// // //     }

// // //     const filtered = users.filter((u) => {
// // //       const raw = u?.[searchCriteria];
// // //       // Handles null/undefined safely for encrypted fields
// // //       const value = raw === null || raw === undefined ? "" : String(raw).toLowerCase();
// // //       return value.includes(term);
// // //     });

// // //     setSearchedUsers(filtered);
// // //   }, [searchCriteria, searchTerm, users]);

// // //   useEffect(() => {
// // //     const fetchUsers = async () => {
// // //       setLoading(true);
// // //       setError(null);
// // //       try {
// // //         // Try the auth endpoint which we verified is working in your terminal
// // //         const res = await axiosClient.get("auth/users/");
// // //         const list = pickUsersFromResponse(res.data);
// // //         setUsers(list);
// // //         setSearchedUsers(list);
// // //       } catch (e) {
// // //         // Fallback to api/users/ if auth fails
// // //         try {
// // //           const res2 = await axiosClient.get("api/users/");
// // //           const list2 = pickUsersFromResponse(res2.data);
// // //           setUsers(list2);
// // //           setSearchedUsers(list2);
// // //         } catch (e2) {
// // //           setError(t("An error occurred while fetching users."));
// // //         }
// // //       } finally {
// // //         setLoading(false);
// // //       }
// // //     };

// // //     fetchUsers();
// // //   }, [t]);

// // //   useEffect(() => {
// // //     handleSearch();
// // //   }, [handleSearch]);


// // //   // ✅ Inside SearchUsers component
// // //   const getRoleDisplay = (role) => {
// // //     switch (role) {
// // //       case "ADMIN":
// // //         return t("Admin");
// // //       case "RECEPTION": 
// // //         return t("Reception");
// // //       case "TECHNICIAN":
// // //         return t("Technician");
// // //       case "MAID":
// // //         return t("Maid");
// // //       case "STAFF":
// // //         return t("Doctor (Staff)");
// // //       default:
// // //         return t("Non Declared");
// // //     }
// // //   };
// // //   // const getRoleDisplay = (role) => {
// // //   //   switch (role) {
// // //   //     case "ADMIN":
// // //   //       return t("Secretary (Admin)");
// // //   //     case "TECHNICIAN": // Updated to match your backend Choice
// // //   //       return t("Technician");
// // //   //     case "STAFF": // Legacy support
// // //   //       return t("Doctor (Staff)");
// // //   //     case "CLIENT": // Legacy support
// // //   //       return t("Patient (Client)");
// // //   //     default:
// // //   //       return t("Non Declared");
// // //   //   }
// // //   // };

// // //   return (
// // //     <Box sx={{ p: { xs: 1, sm: 2 }, display: "flex", justifyContent: "center", minHeight: "100vh" }}>
// // //       <Card elevation={isMobile ? 4 : 16} sx={{ width: "100%", maxWidth: 1000, borderRadius: 2 }}>
// // //         <CardContent sx={{ p: { xs: 2, sm: 3 } }}>
// // //           <Typography variant={isMobile ? "h6" : "h5"} sx={{ mb: 3, textAlign: "center", fontWeight: "bold" }}>
// // //             {t("Search Users")}
// // //           </Typography>

// // //           <Grid container spacing={2} sx={{ mb: 3 }}>
// // //             <Grid item xs={12} sm={4}>
// // //               <FormControl fullWidth size={isMobile ? "small" : "medium"}>
// // //                 <InputLabel>{t("Search By")}</InputLabel>
// // //                 <Select
// // //                   value={searchCriteria}
// // //                   onChange={(e) => setSearchCriteria(e.target.value)}
// // //                   label={t("Search By")}
// // //                 >
// // //                   <MenuItem value="first_name">{t("First Name")}</MenuItem>
// // //                   <MenuItem value="last_name">{t("Last Name")}</MenuItem>
// // //                   <MenuItem value="phone_number">{t("Phone Number")}</MenuItem>
// // //                   <MenuItem value="email">{t("Email")}</MenuItem>
// // //                   <MenuItem value="id_card">{t("ID Card")}</MenuItem>
// // //                   <MenuItem value="city">{t("City")}</MenuItem>
// // //                 </Select>
// // //               </FormControl>
// // //             </Grid>

// // //             <Grid item xs={12} sm={8}>
// // //               <TextField
// // //                 label={t("Enter Search Term")}
// // //                 value={searchTerm}
// // //                 onChange={(e) => setSearchTerm(e.target.value)}
// // //                 fullWidth
// // //                 size={isMobile ? "small" : "medium"}
// // //                 placeholder={t("Type to filter results...")}
// // //               />
// // //             </Grid>
// // //           </Grid>

// // //           {loading && (
// // //             <Box sx={{ display: "flex", justifyContent: "center", my: 4 }}>
// // //               <CircularProgress />
// // //             </Box>
// // //           )}

// // //           {error && (
// // //             <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>
// // //           )}

// // //           <TableContainer component={Paper} sx={{ maxHeight: 600, boxShadow: 'none', border: '1px solid #eee' }}>
// // //             <Table size={isMobile ? "small" : "medium"} stickyHeader>
// // //               <TableHead>
// // //                 <TableRow>
// // //                   <TableCell sx={{ fontWeight: 'bold' }}>{t("Full Name")}</TableCell>
// // //                   <TableCell sx={{ fontWeight: 'bold' }}>{t("Email")}</TableCell>
// // //                   <TableCell sx={{ fontWeight: 'bold' }}>{t("Phone Number")}</TableCell>
// // //                   <TableCell sx={{ fontWeight: 'bold' }}>{t("Role")}</TableCell>
// // //                   <TableCell sx={{ fontWeight: 'bold' }}>{t("City")}</TableCell>
// // //                 </TableRow>
// // //               </TableHead>
// // //               <TableBody>
// // //                 {searchedUsers.length > 0 ? (
// // //                   searchedUsers.map((u) => (
// // //                     <TableRow key={u.id} hover>
// // //                       <TableCell>{`${u.first_name} ${u.last_name}`}</TableCell>
// // //                       <TableCell>{u.email}</TableCell>
// // //                       <TableCell>{u.phone_number}</TableCell>
// // //                       <TableCell>{getRoleDisplay(u.user_role)}</TableCell>
// // //                       <TableCell>{u.city || "-"}</TableCell>
// // //                     </TableRow>
// // //                   ))
// // //                 ) : (
// // //                   !loading && (
// // //                     <TableRow>
// // //                       <TableCell colSpan={5} align="center" sx={{ py: 3 }}>
// // //                         {t("No users found matching your criteria.")}
// // //                       </TableCell>
// // //                     </TableRow>
// // //                   )
// // //                 )}
// // //               </TableBody>
// // //             </Table>
// // //           </TableContainer>
// // //         </CardContent>
// // //       </Card>
// // //     </Box>
// // //   );
// // // };

// // // export default SearchUsers;


// // import { useEffect, useState, useCallback } from "react";
// // import {
// //   TextField,
// //   Button,
// //   Box,
// //   Typography,
// //   Card,
// //   CardContent,
// //   TableContainer,
// //   Table,
// //   TableHead,
// //   TableRow,
// //   TableCell,
// //   TableBody,
// //   Paper,
// //   Select,
// //   MenuItem,
// //   FormControl,
// //   InputLabel,
// //   Grid,
// //   useMediaQuery,
// //   useTheme,
// //   CircularProgress,
// //   Alert,
// //   IconButton,
// //   Tooltip,
// // } from "@mui/material";
// // import { Edit, Delete } from "@mui/icons-material"; // ✅ Added Icons
// // import axiosClient from "../axiosClient";
// // import { useTranslation } from "react-i18next";

// // const pickUsersFromResponse = (data) => {
// //   if (!data) return [];
// //   if (Array.isArray(data)) return data;
// //   if (Array.isArray(data?.results)) return data.results;
// //   if (Array.isArray(data?.custom_users)) return data.custom_users;
// //   if (Array.isArray(data?.users)) return data.users;
// //   return [];
// // };

// // const SearchUsers = () => {
// //   const [searchTerm, setSearchTerm] = useState("");
// //   const [searchCriteria, setSearchCriteria] = useState("first_name");
// //   const [users, setUsers] = useState([]);
// //   const [searchedUsers, setSearchedUsers] = useState([]);
// //   const [loading, setLoading] = useState(false);
// //   const [error, setError] = useState(null);

// //   const { t } = useTranslation();
// //   const theme = useTheme();
// //   const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

// //   const handleSearch = useCallback(() => {
// //     const term = searchTerm.trim().toLowerCase();
// //     if (!term) {
// //       setSearchedUsers(users);
// //       return;
// //     }

// //     const filtered = users.filter((u) => {
// //       const raw = u?.[searchCriteria];
// //       const value = raw === null || raw === undefined ? "" : String(raw).toLowerCase();
// //       return value.includes(term);
// //     });

// //     setSearchedUsers(filtered);
// //   }, [searchCriteria, searchTerm, users]);

// //   const fetchUsers = async () => {
// //     setLoading(true);
// //     setError(null);
// //     try {
// //       const res = await axiosClient.get("auth/users/");
// //       const list = pickUsersFromResponse(res.data);
// //       setUsers(list);
// //       setSearchedUsers(list);
// //     } catch (e) {
// //       setError(t("An error occurred while fetching users."));
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   useEffect(() => {
// //     fetchUsers();
// //   }, [t]);

// //   useEffect(() => {
// //     handleSearch();
// //   }, [handleSearch]);

// //   // ✅ HANDLERS FOR ACTIONS
// //   const handleEdit = (user) => {
// //     console.log("Edit user:", user);
// //     // Logic: Navigate to edit page or open a Dialog/Modal
// //     alert(`${t("Edit functionality for")}: ${user.first_name}`);
// //   };

// //   const handleDelete = async (userId) => {
// //     if (window.confirm(t("Are you sure you want to delete this user?"))) {
// //       try {
// //         await axiosClient.delete(`auth/users/${userId}/`);
// //         // Refresh the list after deletion
// //         fetchUsers();
// //       } catch (err) {
// //         alert(t("Failed to delete user. Ensure you have Admin permissions."));
// //       }
// //     }
// //   };

// //   const getRoleDisplay = (role) => {
// //     switch (role) {
// //       case "ADMIN": return t("Admin");
// //       case "RECEPTION": return t("Reception");
// //       case "TECHNICIAN": return t("Technician");
// //       case "MAID": return t("Maid");
// //       case "STAFF": return t("Doctor (Staff)");
// //       default: return t("Non Declared");
// //     }
// //   };

// //   return (
// //     <Box sx={{ p: { xs: 1, sm: 2 }, display: "flex", justifyContent: "center", minHeight: "100vh" }}>
// //       <Card elevation={isMobile ? 4 : 16} sx={{ width: "100%", maxWidth: 1100, borderRadius: 2 }}>
// //         <CardContent sx={{ p: { xs: 2, sm: 3 } }}>
// //           <Typography variant={isMobile ? "h6" : "h5"} sx={{ mb: 3, textAlign: "center", fontWeight: "bold" }}>
// //             {t("Search Users")}
// //           </Typography>

// //           <Grid container spacing={2} sx={{ mb: 3 }}>
// //             <Grid item xs={12} sm={4}>
// //               <FormControl fullWidth size={isMobile ? "small" : "medium"}>
// //                 <InputLabel>{t("Search By")}</InputLabel>
// //                 <Select
// //                   value={searchCriteria}
// //                   onChange={(e) => setSearchCriteria(e.target.value)}
// //                   label={t("Search By")}
// //                 >
// //                   <MenuItem value="first_name">{t("First Name")}</MenuItem>
// //                   <MenuItem value="last_name">{t("Last Name")}</MenuItem>
// //                   <MenuItem value="phone_number">{t("Phone Number")}</MenuItem>
// //                   <MenuItem value="email">{t("Email")}</MenuItem>
// //                   <MenuItem value="id_card">{t("ID Card")}</MenuItem>
// //                 </Select>
// //               </FormControl>
// //             </Grid>

// //             <Grid item xs={12} sm={8}>
// //               <TextField
// //                 label={t("Enter Search Term")}
// //                 value={searchTerm}
// //                 onChange={(e) => setSearchTerm(e.target.value)}
// //                 fullWidth
// //                 size={isMobile ? "small" : "medium"}
// //                 placeholder={t("Type to filter results...")}
// //               />
// //             </Grid>
// //           </Grid>

// //           {loading && (
// //             <Box sx={{ display: "flex", justifyContent: "center", my: 4 }}>
// //               <CircularProgress />
// //             </Box>
// //           )}

// //           {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

// //           <TableContainer component={Paper} sx={{ maxHeight: 600, boxShadow: 'none', border: '1px solid #eee' }}>
// //             <Table size={isMobile ? "small" : "medium"} stickyHeader>
// //               <TableHead>
// //                 <TableRow>
// //                   <TableCell sx={{ fontWeight: 'bold' }}>{t("Full Name")}</TableCell>
// //                   <TableCell sx={{ fontWeight: 'bold' }}>{t("Email")}</TableCell>
// //                   <TableCell sx={{ fontWeight: 'bold' }}>{t("Role")}</TableCell>
// //                   <TableCell sx={{ fontWeight: 'bold', textAlign: 'center' }}>{t("Actions")}</TableCell>
// //                 </TableRow>
// //               </TableHead>
// //               <TableBody>
// //                 {searchedUsers.length > 0 ? (
// //                   searchedUsers.map((u) => (
// //                     <TableRow key={u.id} hover>
// //                       <TableCell>{`${u.first_name} ${u.last_name}`}</TableCell>
// //                       <TableCell>{u.email}</TableCell>
// //                       <TableCell>{getRoleDisplay(u.user_role)}</TableCell>
                      
// //                       {/* ✅ ACTIONS COLUMN */}
// //                       <TableCell align="center">
// //                         <Tooltip title={t("Edit")}>
// //                           <IconButton onClick={() => handleEdit(u)} color="primary">
// //                             <Edit />
// //                           </IconButton>
// //                         </Tooltip>
// //                         <Tooltip title={t("Delete")}>
// //                           <IconButton onClick={() => handleDelete(u.id)} color="error">
// //                             <Delete />
// //                           </IconButton>
// //                         </Tooltip>
// //                       </TableCell>
// //                     </TableRow>
// //                   ))
// //                 ) : (
// //                   !loading && (
// //                     <TableRow>
// //                       <TableCell colSpan={4} align="center" sx={{ py: 3 }}>
// //                         {t("No users found matching your criteria.")}
// //                       </TableCell>
// //                     </TableRow>
// //                   )
// //                 )}
// //               </TableBody>
// //             </Table>
// //           </TableContainer>
// //         </CardContent>
// //       </Card>
// //     </Box>
// //   );
// // };

// // export default SearchUsers;


// import { useEffect, useState, useCallback } from "react";
// import {
//   TextField,
//   Button,
//   Box,
//   Typography,
//   Card,
//   CardContent,
//   TableContainer,
//   Table,
//   TableHead,
//   TableRow,
//   TableCell,
//   TableBody,
//   Paper,
//   Select,
//   MenuItem,
//   FormControl,
//   InputLabel,
//   Grid,
//   useMediaQuery,
//   useTheme,
//   CircularProgress,
//   Alert,
// } from "@mui/material";
// import axiosClient from "../axiosClient";
// import { useTranslation } from "react-i18next";

// const pickUsersFromResponse = (data) => {
//   if (!data) return [];
//   if (Array.isArray(data)) return data;
//   if (Array.isArray(data?.results)) return data.results;
//   if (Array.isArray(data?.custom_users)) return data.custom_users;
//   if (Array.isArray(data?.users)) return data.users;
//   return [];
// };

// const SearchUsers = () => {
//   const [searchTerm, setSearchTerm] = useState("");
//   const [searchCriteria, setSearchCriteria] = useState("first_name");
//   const [users, setUsers] = useState([]);
//   const [searchedUsers, setSearchedUsers] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);

//   const { t } = useTranslation();
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

//   const handleSearch = useCallback(() => {
//     const term = searchTerm.trim().toLowerCase();
//     if (!term) {
//       setSearchedUsers(users);
//       return;
//     }

//     const filtered = users.filter((u) => {
//       const raw = u?.[searchCriteria];
//       const value = raw === null || raw === undefined ? "" : String(raw).toLowerCase();
//       return value.includes(term);
//     });

//     setSearchedUsers(filtered);
//   }, [searchCriteria, searchTerm, users]);

//   useEffect(() => {
//     const fetchUsers = async () => {
//       setLoading(true);
//       setError(null);
//       try {
//         const res = await axiosClient.get("auth/users/");
//         const list = pickUsersFromResponse(res.data);
//         setUsers(list);
//         setSearchedUsers(list);
//       } catch (e) {
//         setError(t("An error occurred while fetching users."));
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchUsers();
//   }, [t]);

//   useEffect(() => {
//     handleSearch();
//   }, [handleSearch]);

//   // ✅ Fixed Role Display logic to include your new roles
//   const getRoleDisplay = (role) => {
//     switch (role) {
//       case "ADMIN":
//         return t("Admin");
//       case "RECEPTION": 
//         return t("Reception");
//       case "TECHNICIAN":
//         return t("Technician");
//       case "MAID":
//         return t("Maid");
//       case "STAFF":
//         return t("Doctor (Staff)");
//       case "CLIENT":
//         return t("Patient (Client)");
//       default:
//         return t("Non Declared");
//     }
//   };

//   return (
//     <Box sx={{ p: { xs: 1, sm: 2 }, display: "flex", justifyContent: "center", minHeight: "100vh" }}>
//       <Card elevation={isMobile ? 4 : 16} sx={{ width: "100%", maxWidth: 1000, borderRadius: 2 }}>
//         <CardContent sx={{ p: { xs: 2, sm: 3 } }}>
//           <Typography variant={isMobile ? "h6" : "h5"} sx={{ mb: 3, textAlign: "center", fontWeight: "bold" }}>
//             {t("Search Users")}
//           </Typography>

//           <Grid container spacing={2} sx={{ mb: 3 }}>
//             <Grid item xs={12} sm={4}>
//               <FormControl fullWidth size={isMobile ? "small" : "medium"}>
//                 <InputLabel>{t("Search By")}</InputLabel>
//                 <Select
//                   value={searchCriteria}
//                   onChange={(e) => setSearchCriteria(e.target.value)}
//                   label={t("Search By")}
//                 >
//                   <MenuItem value="first_name">{t("First Name")}</MenuItem>
//                   <MenuItem value="last_name">{t("Last Name")}</MenuItem>
//                   <MenuItem value="phone_number">{t("Phone Number")}</MenuItem>
//                   <MenuItem value="email">{t("Email")}</MenuItem>
//                   <MenuItem value="id_card">{t("ID Card")}</MenuItem>
//                   <MenuItem value="city">{t("City")}</MenuItem>
//                 </Select>
//               </FormControl>
//             </Grid>

//             <Grid item xs={12} sm={8}>
//               <TextField
//                 label={t("Enter Search Term")}
//                 value={searchTerm}
//                 onChange={(e) => setSearchTerm(e.target.value)}
//                 fullWidth
//                 size={isMobile ? "small" : "medium"}
//                 placeholder={t("Type to filter results...")}
//               />
//             </Grid>
//           </Grid>

//           {loading && (
//             <Box sx={{ display: "flex", justifyContent: "center", my: 4 }}>
//               <CircularProgress />
//             </Box>
//           )}

//           {error && (
//             <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>
//           )}

//           <TableContainer component={Paper} sx={{ maxHeight: 600, boxShadow: 'none', border: '1px solid #eee' }}>
//             <Table size={isMobile ? "small" : "medium"} stickyHeader>
//               <TableHead>
//                 <TableRow>
//                   <TableCell sx={{ fontWeight: 'bold' }}>{t("Full Name")}</TableCell>
//                   <TableCell sx={{ fontWeight: 'bold' }}>{t("Email")}</TableCell>
//                   <TableCell sx={{ fontWeight: 'bold' }}>{t("Phone Number")}</TableCell>
//                   <TableCell sx={{ fontWeight: 'bold' }}>{t("Role")}</TableCell>
//                   <TableCell sx={{ fontWeight: 'bold' }}>{t("City")}</TableCell>
//                 </TableRow>
//               </TableHead>
//               <TableBody>
//                 {searchedUsers.length > 0 ? (
//                   searchedUsers.map((u) => (
//                     <TableRow key={u.id} hover>
//                       <TableCell>{`${u.first_name} ${u.last_name}`}</TableCell>
//                       <TableCell>{u.email}</TableCell>
//                       <TableCell>{u.phone_number}</TableCell>
//                       <TableCell>{getRoleDisplay(u.user_role)}</TableCell>
//                       <TableCell>{u.city || "-"}</TableCell>
//                     </TableRow>
//                   ))
//                 ) : (
//                   !loading && (
//                     <TableRow>
//                       <TableCell colSpan={5} align="center" sx={{ py: 3 }}>
//                         {t("No users found matching your criteria.")}
//                       </TableCell>
//                     </TableRow>
//                   )
//                 )}
//               </TableBody>
//             </Table>
//           </TableContainer>
//         </CardContent>
//       </Card>
//     </Box>
//   );
// };

// export default SearchUsers;


import { useEffect, useState, useCallback } from "react";
import {
  TextField,
  Box,
  Typography,
  Card,
  CardContent,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Grid,
  useMediaQuery,
  useTheme,
  CircularProgress,
  Alert,
} from "@mui/material";
import axiosClient from "../axiosClient";
import { useTranslation } from "react-i18next";

const pickUsersFromResponse = (data) => {
  if (!data) return [];
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.results)) return data.results;
  if (Array.isArray(data?.custom_users)) return data.custom_users;
  if (Array.isArray(data?.users)) return data.users;
  return [];
};

const SearchUsers = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [searchCriteria, setSearchCriteria] = useState("first_name");
  const [users, setUsers] = useState([]);
  const [searchedUsers, setSearchedUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const handleSearch = useCallback(() => {
    const term = searchTerm.trim().toLowerCase();
    if (!term) {
      setSearchedUsers(users);
      return;
    }

    const filtered = users.filter((u) => {
      const raw = u?.[searchCriteria];
      const value = raw === null || raw === undefined ? "" : String(raw).toLowerCase();
      return value.includes(term);
    });

    setSearchedUsers(filtered);
  }, [searchCriteria, searchTerm, users]);

  useEffect(() => {
    const fetchUsers = async () => {
      setLoading(true);
      setError(null);
      try {
        const res = await axiosClient.get("auth/users/");
        const list = pickUsersFromResponse(res.data);
        setUsers(list);
        setSearchedUsers(list);
      } catch (e) {
        setError(t("An error occurred while fetching users."));
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
  }, [t]);

  useEffect(() => {
    handleSearch();
  }, [handleSearch]);

  const getRoleDisplay = (role) => {
    switch (role) {
      case "ADMIN":
        return t("Admin");
      case "RECEPTION": 
        return t("Reception");
      case "TECHNICIAN":
        return t("Technician");
      case "MAID":
        return t("Maid");
      case "STAFF":
        return t("Doctor (Staff)");
      case "CLIENT":
        return t("Patient (Client)");
      default:
        return t("Non Declared");
    }
  };

  return (
    <Box sx={{ p: { xs: 1, sm: 2 }, display: "flex", justifyContent: "center", minHeight: "100vh" }}>
      <Card elevation={isMobile ? 4 : 16} sx={{ width: "100%", maxWidth: 1000, borderRadius: 2 }}>
        <CardContent sx={{ p: { xs: 2, sm: 3 } }}>
          <Typography variant={isMobile ? "h6" : "h5"} sx={{ mb: 3, textAlign: "center", fontWeight: "bold" }}>
            {t("Search Users")}
          </Typography>

          <Grid container spacing={2} sx={{ mb: 3 }}>
            <Grid item xs={12} sm={4}>
              <FormControl fullWidth size={isMobile ? "small" : "medium"}>
                <InputLabel>{t("Search By")}</InputLabel>
                <Select
                  value={searchCriteria}
                  onChange={(e) => setSearchCriteria(e.target.value)}
                  label={t("Search By")}
                >
                  <MenuItem value="first_name">{t("First Name")}</MenuItem>
                  <MenuItem value="last_name">{t("Last Name")}</MenuItem>
                  <MenuItem value="phone_number">{t("Phone Number")}</MenuItem>
                  <MenuItem value="email">{t("Email")}</MenuItem>
                  {/* ✅ Removed ID CARD and CITY from search criteria */}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={8}>
              <TextField
                label={t("Enter Search Term")}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                fullWidth
                size={isMobile ? "small" : "medium"}
                placeholder={t("Type to filter results...")}
              />
            </Grid>
          </Grid>

          {loading && (
            <Box sx={{ display: "flex", justifyContent: "center", my: 4 }}>
              <CircularProgress />
            </Box>
          )}

          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>
          )}

          <TableContainer component={Paper} sx={{ maxHeight: 600, boxShadow: 'none', border: '1px solid #eee' }}>
            <Table size={isMobile ? "small" : "medium"} stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontWeight: 'bold' }}>{t("Full Name")}</TableCell>
                  <TableCell sx={{ fontWeight: 'bold' }}>{t("Email")}</TableCell>
                  <TableCell sx={{ fontWeight: 'bold' }}>{t("Phone Number")}</TableCell>
                  <TableCell sx={{ fontWeight: 'bold' }}>{t("Role")}</TableCell>
                  {/* ✅ Removed City column header */}
                </TableRow>
              </TableHead>
              <TableBody>
                {searchedUsers.length > 0 ? (
                  searchedUsers.map((u) => (
                    <TableRow key={u.id} hover>
                      <TableCell>{`${u.first_name} ${u.last_name}`}</TableCell>
                      <TableCell>{u.email}</TableCell>
                      <TableCell>{u.phone_number}</TableCell>
                      <TableCell>{getRoleDisplay(u.user_role)}</TableCell>
                      {/* ✅ Removed City data cell */}
                    </TableRow>
                  ))
                ) : (
                  !loading && (
                    <TableRow>
                      <TableCell colSpan={4} align="center" sx={{ py: 3 }}>
                        {t("No users found matching your criteria.")}
                      </TableCell>
                    </TableRow>
                  )
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </CardContent>
      </Card>
    </Box>
  );
};

export default SearchUsers;